// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1793611775837
      var cssReload = require("E:/web/medical/medical-student/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  